// extracted by mini-css-extract-plugin
export var disabledPageLinkText = "search-result-paging-row-module--disabledPageLinkText--f17e2";
export var displayingItemsCountText = "search-result-paging-row-module--displayingItemsCountText--ad15d";
export var pageLinkRow = "search-result-paging-row-module--pageLinkRow--3bd85";
export var pageLinkText = "search-result-paging-row-module--pageLinkText--4922c";
export var parkingListHeader = "search-result-paging-row-module--parkingListHeader--91a6e";
export var sortMenuButton = "search-result-paging-row-module--sortMenuButton--c5348";